import { getSDSizeForYoutube } from './image';

export function getVideoId(mediaUrl) {
  const regExp = /^.*(youtu\.be\/|v\/|u\/\w\/|embed\/|watch\?v=|&v=)([^#&?]*).*/;
  const match = mediaUrl.match(regExp);
  if (match && match[2].length === 11) {
    return match[2];
  }

  return '';
}

export function getVideoImageUrl(mediaUrl) {
  const id = getVideoId(mediaUrl);
  if (!id) {
    return 'https://snapask.co/assets/img/icon/apple-touch-icon-180x180.png';
  }

  return getSDSizeForYoutube(id);
}

export const generateUrlParams = config =>
  Object.keys(config)
    .filter(key => config[key] !== undefined)
    .map(key => `${key}=${config[key]}`)
    .join('&');

export function getVideoUrl(config) {
  return videoUrl => `${videoUrl}?${generateUrlParams(config)}`;
}

function padLeft(num, len) {
  const str = `${num}`;

  return str.length >= len
    ? str
    : new Array(len - str.length + 1).join('0') + str;
}

function padRight(num, len) {
  const str = `${num}`;

  return str.length >= len
    ? str
    : str + new Array(len - str.length + 1).join('0');
}
export function formatDurationTime(time) {
  const quotient = time ? Math.trunc(time / 60) : 0;
  const remainder = time ? time % 60 : 0;

  return `${padLeft(quotient, 2)}:${padRight(remainder, 2)}`;
}



// WEBPACK FOOTER //
// ./app/utils/youtube.js